
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import ABarcodeActionsComponent from './ABarcodeActionsComponent';
import ApiProvider from 'Api/ApiProvider';
import { ScannedBarcode, ScannedBarcodeState, 
    UpdateBarcodeListCommandArguments, UpdateBarcodeListCommandArgumentsState, 
    DownloadBarcodeListRequestArguments, ConfirmItemsReceivedCommandResponse, 
    ConfirmItemReceivedViewModel, 
    ScannedBarcodeDetailsViewModel} from 'Api/CoreApi';
    import barcodestore from 'Store/barcode/barcodestore';
    import ABaseComponent from 'Components/Base/ABaseComponent';
import { ApiException } from 'Api/DynamicwebApi';
    
    
    @Component({
        template: '#barcode-confirm-item-received-template'
    })
    export class BarcodeConfirmItemReceivedComponent extends ABarcodeActionsComponent  {
        
        
        list: ConfirmItemReceivedViewModel[] = null;
        
        
        async created() {
            
            
            this.availableStates = Object.keys(ScannedBarcodeState)
            .filter(value => value == ScannedBarcodeState.CUSEX 
                || value == ScannedBarcodeState.CUSIN);
           
                
                this.setLoading();
                
                
                // if(!this.barcodes || this.barcodes.length == 0)
                //     this.addBarcode(null);
                    
                this.setLoaded();
            }
            
            
            getBarcodeDetails(index: number): ScannedBarcodeDetailsViewModel{
                
                if(!this.list) return;
                if(!this.list[index] || !this.list[index].details) return;
                return this.list[index].details;
            }
            
            
            async exportValidatedBarcodes(){
                if(!this.list) return;
                //map model to export obj
                
                const client = ApiProvider.getApiClient();
                const result = await client.downloadScannedBarcodes(<DownloadBarcodeListRequestArguments>{
                    list: this.list
                });
                

                await this.export(this.selectedState,result.json);
            }
            clearList(){
                this.list = [];
                barcodestore.clearList();
                barcodestore.add();
            }
            async validateScannedBarcodes(){ 
               
                
                this.triggerValidateOnTable = false;
                this.waiting = true;
                this.errorValidate = false;
                this._isValidated = false;
                

                    this.triggerValidateOnTable = true;                    
                try{
                   
                    
                    const result = await this.validate(this.selectedState);
                    this._isValidated = result.isValid;
                    this.errorValidate = !result.isValid;
                    
                }catch(error){
                    this.errorValidate = true;
                    console.log(error);
                    console.log(this.list);
                    
                }

                this.waiting = false;
            }
            
         

            async validate(state: string): Promise<ConfirmItemsReceivedCommandResponse>{
                
                if(!this.barcodes) return;

                const distinctBarcodeNo = (value: ScannedBarcode, index: number, collection: ScannedBarcode[]) => {
                    return collection.map(x => x.number).indexOf(value.number) === index;
                }
                //remove duplicates
                let distinctBarcodes = this.barcodes.filter(distinctBarcodeNo)
             
                

                const client = ApiProvider.getApiClient();
                
                
                const result = await client.confirmItemsReceived(<UpdateBarcodeListCommandArguments>{
                    state: state as UpdateBarcodeListCommandArgumentsState,
                    scannedBarcodeList: distinctBarcodes
                });
              
                barcodestore.updateList(result.list.map(x => x.item));
                
                this.list = result.list;
                
                //map validated barcodes to store !
                //add validation list to component
                return result;
            }
            
            
        }
        Vue.component('barcode-confirm-item-received', BarcodeConfirmItemReceivedComponent);